module.exports = __webpack_public_path__ + "img/base-map-pastel.e8a04a39.png";